module.exports = __webpack_public_path__ + "img/headerlogo.f904514c.svg";